export const works = [
  {
    id: "silent-testimony",
    title: "静默的证词",
    type: "movie",
    year: 2023,
    genres: ["社会伦理", "悬疑伦理"],
    rating: 8.4,
    poster:
      "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20cinematic%20film%20poster%20illustration%2C%20a%20lone%20lawyer%20silhouette%20facing%20rain-streaked%20courthouse%20windows%2C%20moody%20intimate%20atmosphere%2C%20muted%20navy%20blue%20and%20warm%20amber%20tones%2C%20soft%20gradient%20background%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20no%20text&width=600&height=900&seq=kr-poster-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20wide%20artistic%20film%20still%20of%20a%20rain-soaked%20city%20courthouse%20at%20night%2C%20moody%20deep%20navy%20tones%20with%20warm%20window%20light%2C%20atmospheric%20rain%20reflections%2C%20stylized%20cinematography%2C%20no%20text&width=1600&height=900&seq=kr-back-01&orientation=landscape",
    director: "朴承延",
    cast: ["黄敏书", "郑在浩", "李恩珠"],
    duration: "141 分钟",
    tags: ["法庭", "真相", "伦理抉择"],
    views: 128400,
    createdAt: "2024-09-18",
    synopsis: [
      "一名坚持原则的辩护律师接到一桩看似普通的案件，却在证据的缝隙里发现整座城市都在默契地沉默。当他试图追问真相时，自己的职业与家庭也开始被推上审判席。",
      "影片以克制的镜头语言讨论「沉默是否也是一种共谋」，把个人良知放在集体压力之下反复拷问，是近年社会伦理题材中少见的结构严谨之作。",
    ],
    reviews: [
      {
        author: "沈知远",
        date: "2024-09-21",
        content:
          "它没有把正义拍成热血宣言，而是拍成一次次艰难的取舍。结尾那场长时间的沉默，比任何台词都更有力量。",
      },
      {
        author: "影评人 · 林晚",
        date: "2024-09-25",
        content:
          "导演对空间的调度非常高级，法庭的冷光与家中的暖光形成对照，暗示主角在两个世界之间来回撕裂。",
      },
    ],
  },
  {
    id: "misty-riverbank",
    title: "雾中河岸",
    type: "movie",
    year: 2024,
    genres: ["心理伦理", "爱情伦理"],
    rating: 8.1,
    poster:
      "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20cinematic%20film%20poster%20illustration%2C%20a%20solitary%20woman%20standing%20on%20a%20foggy%20riverbank%20at%20dusk%2C%20moody%20intimate%20atmosphere%2C%20muted%20navy%20blue%20and%20warm%20amber%20tones%2C%20soft%20gradient%20background%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20no%20text&width=600&height=900&seq=kr-poster-02&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Atmospheric%20cinematic%20wide%20artistic%20film%20still%20of%20a%20foggy%20river%20at%20dawn%20with%20a%20distant%20lone%20figure%2C%20muted%20blue%20cinematic%20tones%2C%20soft%20mist%2C%20stylized%20cinematography%2C%20no%20text&width=1600&height=900&seq=kr-back-02&orientation=landscape",
    director: "尹知恩",
    cast: ["徐雅琳", "姜道允"],
    duration: "118 分钟",
    tags: ["记忆", "创伤", "缓慢叙事"],
    views: 96200,
    createdAt: "2024-08-30",
    synopsis: [
      "一位心理咨询师回到故乡，试图整理母亲留下的旧屋，却在河岸的雾气中重新遇见了自己刻意遗忘的过去。她开始怀疑，那些被反复讲述的记忆到底是谁的版本。",
      "影片用大量留白与长镜头描摹内心的潮汐，把「如何与自己和解」这个心理伦理命题拍得温柔而锋利。",
    ],
    reviews: [
      {
        author: "周叙",
        date: "2024-09-02",
        content:
          "像一首慢慢展开的散文诗。它不急于给出答案，而是让你和主人公一起在雾里站一会儿。",
      },
    ],
  },
  {
    id: "spring-confession",
    title: "春日告白",
    type: "movie",
    year: 2022,
    genres: ["爱情伦理"],
    rating: 7.9,
    poster:
      "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20cinematic%20film%20poster%20illustration%2C%20two%20distant%20figures%20on%20a%20blooming%20spring%20street%20at%20golden%20hour%2C%20moody%20intimate%20atmosphere%2C%20muted%20navy%20blue%20and%20warm%20amber%20tones%2C%20soft%20gradient%20background%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20no%20text&width=600&height=900&seq=kr-poster-03&orientation=portrait",
    director: "崔敏贞",
    cast: ["韩素拉", "白贤宇"],
    duration: "126 分钟",
    tags: ["重逢", "错过", "克制之爱"],
    views: 87300,
    createdAt: "2024-06-12",
    synopsis: [
      "两个在青春期彼此错过的人，多年后在樱花盛开的城市里再度相遇。他们都已经有了各自的生活，却不得不在一个春天的傍晚，把当年没说出口的话重新拿出来面对。",
      "影片讨论的是「在对的时间遇见错的人」，如何诚实面对感情，又不伤害身边的人。",
    ],
    reviews: [
      {
        author: "顾南枝",
        date: "2024-06-15",
        content: "细节动人，尤其是两人并肩走过长廊却始终没有牵手的那个镜头。",
      },
    ],
  },
  {
    id: "mothers-room",
    title: "母亲的房间",
    type: "movie",
    year: 2021,
    genres: ["家庭伦理"],
    rating: 8.6,
    poster:
      "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20cinematic%20film%20poster%20illustration%2C%20a%20quiet%20empty%20room%20with%20warm%20lamplight%20and%20an%20old%20armchair%2C%20moody%20intimate%20atmosphere%2C%20muted%20navy%20blue%20and%20warm%20amber%20tones%2C%20soft%20gradient%20background%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20no%20text&width=600&height=900&seq=kr-poster-04&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Warm%20nostalgic%20cinematic%20wide%20artistic%20film%20still%20of%20a%20quiet%20family%20home%20interior%20lit%20by%20soft%20afternoon%20light%2C%20muted%20warm%20amber%20tones%2C%20stylized%20cinematography%2C%20no%20text&width=1600&height=900&seq=kr-back-03&orientation=landscape",
    director: "金泰河",
    cast: ["文贞淑", "朴海仁", "赵成奎"],
    duration: "133 分钟",
    tags: ["亲情", "告别", "家庭秘密"],
    views: 142100,
    createdAt: "2024-05-08",
    synopsis: [
      "母亲去世后，三兄妹回到老屋整理遗物，却在一间从不让任何人进入的房间里，发现了母亲隐藏了半生的另一段人生。",
      "影片以一个家庭的裂痕，映照整个社会对女性角色的沉默期待，是家庭伦理题材里情感浓度极高的作品。",
    ],
    reviews: [
      {
        author: "叶知秋",
        date: "2024-05-11",
        content:
          "看完久久说不出话。它让你重新审视自己是否真的了解最亲近的人。",
      },
      {
        author: "影评人 · 陈默",
        date: "2024-05-19",
        content: "表演真挚，剧本扎实，把「家」的双重性写得很透。",
      },
    ],
  },
  {
    id: "woman-on-cliff",
    title: "悬崖上的女人",
    type: "movie",
    year: 2023,
    genres: ["心理伦理", "悬疑伦理"],
    rating: 8.2,
    poster:
      "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20cinematic%20film%20poster%20illustration%2C%20a%20woman%20in%20a%20long%20coat%20standing%20on%20a%20windswept%20cliff%20edge%2C%20moody%20intimate%20atmosphere%2C%20muted%20navy%20blue%20and%20warm%20amber%20tones%2C%20soft%20gradient%20background%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20no%20text&width=600&height=900&seq=kr-poster-05&orientation=portrait",
    director: "李昌勋",
    cast: ["徐雅琳", "金宇振"],
    duration: "124 分钟",
    tags: ["自我", "边界", "悬念"],
    views: 77800,
    createdAt: "2024-07-21",
    synopsis: [
      "一位画家在海边小镇独居，她的画作开始出现她自己都不知道的细节。随着调查深入，她分不清究竟是谁在操控她的记忆。",
      "影片把心理伦理与悬疑巧妙结合，讨论一个人的自我认知可以被多大程度地改写。",
    ],
    reviews: [
      {
        author: "许一诺",
        date: "2024-07-25",
        content: "氛围感极强，越到后面越冷，最后十分钟彻底颠覆前面的理解。",
      },
    ],
  },
  {
    id: "night-train",
    title: "夜行列车",
    type: "movie",
    year: 2020,
    genres: ["社会伦理"],
    rating: 7.7,
    poster:
      "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20cinematic%20film%20poster%20illustration%2C%20a%20passenger%20gazing%20out%20of%20a%20night%20train%20window%20with%20blurred%20lights%2C%20moody%20intimate%20atmosphere%2C%20muted%20navy%20blue%20and%20warm%20amber%20tones%2C%20soft%20gradient%20background%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20no%20text&width=600&height=900&seq=kr-poster-06&orientation=portrait",
    director: "吴世真",
    cast: ["河俊浩", "林秀晶"],
    duration: "112 分钟",
    tags: ["陌生人", "旅途", "选择"],
    views: 61300,
    createdAt: "2024-04-02",
    synopsis: [
      "一趟驶向边陲的夜行列车上，五个陌生人被迫共处一夜。当列车因故停驶，他们不得不面对各自逃向远方的理由。",
      "影片用密闭空间讨论道德困境：当没有人看见时，我们还会选择做对的事吗？",
    ],
    reviews: [
      {
        author: "叶知秋",
        date: "2024-04-05",
        content: "小成本大格局，靠对话和表演撑起整部电影。",
      },
    ],
  },
  {
    id: "blue-echo",
    title: "蓝色回响",
    type: "movie",
    year: 2024,
    genres: ["爱情伦理"],
    rating: 8.0,
    poster:
      "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20cinematic%20film%20poster%20illustration%2C%20two%20lovers%20silhouette%20against%20deep%20blue%20twilight%20water%20reflection%2C%20moody%20intimate%20atmosphere%2C%20muted%20navy%20blue%20and%20warm%20amber%20tones%2C%20soft%20gradient%20background%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20no%20text&width=600&height=900&seq=kr-poster-07&orientation=portrait",
    director: "崔敏贞",
    cast: ["韩素拉", "姜道允"],
    duration: "121 分钟",
    tags: ["异乡", "留守", "身份"],
    views: 83500,
    createdAt: "2024-09-05",
    synopsis: [
      "一对在异国打拼的伴侣，为了留在同一座城市做出了不同的妥协。当其中一人得到命运的转机，他们的关系也来到必须重新定义的岸边。",
      "影片温柔地追问：爱一个人，是留下还是成全？",
    ],
    reviews: [
      {
        author: "顾南枝",
        date: "2024-09-08",
        content: "画面美到窒息，情感却始终克制，是一部越看越有回味的作品。",
      },
    ],
  },
  {
    id: "silent-neighbor",
    title: "沉默的邻居",
    type: "movie",
    year: 2022,
    genres: ["悬疑伦理", "社会伦理"],
    rating: 8.3,
    poster:
      "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20cinematic%20film%20poster%20illustration%2C%20an%20apartment%20corridor%20with%20a%20single%20lit%20doorway%20at%20night%2C%20moody%20intimate%20atmosphere%2C%20muted%20navy%20blue%20and%20warm%20amber%20tones%2C%20soft%20gradient%20background%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20no%20text&width=600&height=900&seq=kr-poster-08&orientation=portrait",
    director: "李昌勋",
    cast: ["郑在浩", "朴海仁"],
    duration: "129 分钟",
    tags: ["旁观", "集体", "责任"],
    views: 101200,
    createdAt: "2024-06-28",
    synopsis: [
      "整栋楼的住户都听见了那晚的争吵，却没有人报警。一年后，一个搬走的旧住户决定回来问清楚，究竟是什么让他们集体选择了沉默。",
      "影片冷静地解剖「旁观者效应」，让每个人都无法轻易站在道德高地。",
    ],
    reviews: [
      {
        author: "沈知远",
        date: "2024-07-02",
        content: "结构像一部社会调查，克制却让人如坐针毡。",
      },
    ],
  },
  {
    id: "winter-letters",
    title: "冬日的信件",
    type: "movie",
    year: 2019,
    genres: ["家庭伦理", "爱情伦理"],
    rating: 8.5,
    poster:
      "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20cinematic%20film%20poster%20illustration%2C%20hands%20holding%20old%20letters%20by%20a%20frosty%20window%20in%20winter%2C%20moody%20intimate%20atmosphere%2C%20muted%20navy%20blue%20and%20warm%20amber%20tones%2C%20soft%20gradient%20background%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20no%20text&width=600&height=900&seq=kr-poster-09&orientation=portrait",
    director: "金泰河",
    cast: ["文贞淑", "河俊浩"],
    duration: "137 分钟",
    tags: ["书信", "和解", "时间"],
    views: 118900,
    createdAt: "2024-02-14",
    synopsis: [
      "一个女儿在整理父亲旧物时，发现了几十封从未寄出的信。她循着信里的地址，走进父亲从未向她提起过的另一段人生。",
      "影片用缓慢的节奏让两代人的误解一点点融化，是家庭伦理中难得的温柔之作。",
    ],
    reviews: [
      {
        author: "陈默",
        date: "2024-02-18",
        content: "没有大起大落，但每一封信都像在心上轻轻按了一下。",
      },
    ],
  },
  {
    id: "eclipse-ethic",
    title: "蚀",
    type: "movie",
    year: 2021,
    genres: ["爱情伦理", "心理伦理"],
    rating: 7.8,
    poster:
      "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20cinematic%20film%20poster%20illustration%2C%20a%20couple%20shadowed%20profiles%20under%20partial%20eclipse%20light%2C%20moody%20intimate%20atmosphere%2C%20muted%20navy%20blue%20and%20warm%20amber%20tones%2C%20soft%20gradient%20background%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20no%20text&width=600&height=900&seq=kr-poster-10&orientation=portrait",
    director: "吴世真",
    cast: ["林秀晶", "白贤宇"],
    duration: "115 分钟",
    tags: ["占有", "欺骗", "清醒"],
    views: 58900,
    createdAt: "2024-03-19",
    synopsis: [
      "一对看似完美的伴侣，在一次日蚀之下的旅行中，彼此隐藏的秘密同时浮出水面。他们要面对的，是爱里那些不愿承认的算计。",
      "影片以冷静的笔触讨论亲密关系中的诚实边界。",
    ],
    reviews: [
      {
        author: "许一诺",
        date: "2024-03-22",
        content: "前半段温柔，后半段锋利，反转建立在人性逻辑上，很扎实。",
      },
    ],
  },
  {
    id: "city-of-morality",
    title: "伦理之城",
    type: "drama",
    year: 2024,
    genres: ["社会伦理", "都市伦理"],
    rating: 8.7,
    poster:
      "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20cinematic%20korean%20drama%20poster%20illustration%2C%20a%20dense%20modern%20city%20skyline%20at%20night%20with%20one%20glowing%20window%2C%20moody%20intimate%20atmosphere%2C%20muted%20navy%20blue%20and%20warm%20amber%20tones%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20no%20text&width=600&height=900&seq=kr-poster-11&orientation=portrait",
    director: "编导 · 姜瑞镇",
    cast: ["黄敏书", "徐雅琳", "赵成奎"],
    episodes: 16,
    tags: ["群像", "道德困境", "都市"],
    views: 156700,
    createdAt: "2024-09-24",
    synopsis: [
      "一座高速运转的城市里，医生、记者、教师与商人因为一起公共事件被命运绑在一起。每个人都自认站在正义一侧，却共同把局面推向失控。",
      "剧集以多线群像的方式追问：当规则与良知冲突，我们究竟该忠于哪一个？",
    ],
    reviews: [
      {
        author: "林晚",
        date: "2024-09-27",
        content: "节奏紧凑，每个角色都立体可恨又可怜，是今年最敢写的都市伦理剧。",
      },
      {
        author: "沈知远",
        date: "2024-10-01",
        content: "台词锋利，毫不回避现实问题，值得慢慢品味。",
      },
    ],
  },
  {
    id: "double-life",
    title: "双面人生",
    type: "drama",
    year: 2023,
    genres: ["心理伦理", "悬疑伦理"],
    rating: 8.4,
    poster:
      "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20cinematic%20korean%20drama%20poster%20illustration%2C%20a%20split%20portrait%20silhouette%20of%20one%20person%20in%20two%20moods%2C%20moody%20intimate%20atmosphere%2C%20muted%20navy%20blue%20and%20warm%20amber%20tones%2C%20soft%20gradient%20background%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20no%20text&width=600&height=900&seq=kr-poster-12&orientation=portrait",
    director: "编导 · 尹知恩",
    cast: ["韩素拉", "金宇振"],
    episodes: 12,
    tags: ["人格", "真相", "反转"],
    views: 132400,
    createdAt: "2024-08-12",
    synopsis: [
      "一位温和的图书管理员在下班后过着完全不同的生活。当两条人生轨迹意外交叉，她必须在被揭穿之前，先弄清楚自己究竟是谁。",
      "剧集把心理伦理与悬疑节奏结合，探讨自我认同与道德责任的边界。",
    ],
    reviews: [
      {
        author: "叶知秋",
        date: "2024-08-16",
        content: "女主的表演分裂感十足，看到第五集开始后背发凉。",
      },
    ],
  },
  {
    id: "gangnam-apartment",
    title: "江南公寓",
    type: "drama",
    year: 2022,
    genres: ["都市伦理", "家庭伦理"],
    rating: 8.0,
    poster:
      "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20cinematic%20korean%20drama%20poster%20illustration%2C%20modern%20high-rise%20apartment%20balconies%20at%20evening%2C%20moody%20intimate%20atmosphere%2C%20muted%20navy%20blue%20and%20warm%20amber%20tones%2C%20soft%20gradient%20background%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20no%20text&width=600&height=900&seq=kr-poster-13&orientation=portrait",
    director: "编导 · 崔敏贞",
    cast: ["郑在浩", "朴海仁", "白贤宇"],
    episodes: 20,
    tags: ["阶层", "邻里", "现实"],
    views: 98700,
    createdAt: "2024-07-03",
    synopsis: [
      "同一栋高端公寓里，住在顶层的家庭与地下储物间的管理员，因为一桩漏水纠纷被迫频繁接触。两个阶层的世界观在无数日常细节中不断碰撞。",
      "剧集用生活流的叙事，呈现都市中隐形的阶层伦理。",
    ],
    reviews: [
      {
        author: "顾南枝",
        date: "2024-07-09",
        content: "很生活，很扎心，很多对白都像从我身边抄来的。",
      },
    ],
  },
  {
    id: "her-secret",
    title: "她的秘密",
    type: "drama",
    year: 2024,
    genres: ["悬疑伦理", "心理伦理"],
    rating: 8.5,
    poster:
      "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20cinematic%20korean%20drama%20poster%20illustration%2C%20a%20woman%20silhouette%20behind%20a%20translucent%20curtain%2C%20moody%20intimate%20atmosphere%2C%20muted%20navy%20blue%20and%20warm%20amber%20tones%2C%20soft%20gradient%20background%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20no%20text&width=600&height=900&seq=kr-poster-14&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20artistic%20film%20still%20of%20an%20elegant%20Seoul%20apartment%20at%20dusk%20with%20moody%20warm%20lighting%20through%20sheer%20curtains%2C%20stylized%20cinematography%2C%20no%20text&width=1600&height=900&seq=kr-back-04&orientation=landscape",
    director: "编导 · 李昌勋",
    cast: ["徐雅琳", "河俊浩"],
    episodes: 14,
    tags: ["秘密", "信任", "反转"],
    views: 143800,
    createdAt: "2024-10-01",
    synopsis: [
      "一个被邻里称道的好妻子、好母亲，在丈夫意外去世后，一步步被揭开她精心维护的另一副面孔。越是接近真相，越没有人愿意相信。",
      "剧集讨论「我们爱的是真实的她，还是我们愿意相信的她」。",
    ],
    reviews: [
      {
        author: "陈默",
        date: "2024-10-05",
        content: "悬念铺得稳，情感也够，女主的内心戏让人心疼又害怕。",
      },
    ],
  },
  {
    id: "road-home",
    title: "归家之路",
    type: "drama",
    year: 2021,
    genres: ["家庭伦理"],
    rating: 8.2,
    poster:
      "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20cinematic%20korean%20drama%20poster%20illustration%2C%20a%20lone%20traveler%20walking%20a%20country%20road%20toward%20distant%20warm%20lights%2C%20moody%20intimate%20atmosphere%2C%20muted%20navy%20blue%20and%20warm%20amber%20tones%2C%20soft%20gradient%20background%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20no%20text&width=600&height=900&seq=kr-poster-15&orientation=portrait",
    director: "编导 · 金泰河",
    cast: ["文贞淑", "赵成奎"],
    episodes: 24,
    tags: ["亲情", "故乡", "成长"],
    views: 86900,
    createdAt: "2024-05-22",
    synopsis: [
      "离乡多年的长子因为父亲的病回到小镇，才发现记忆中的家早已变了模样。他与固执的父母、陌生的弟妹，要用一整个夏天重新学习如何成为家人。",
      "剧集以四季为轴，温暖而不煽情地讲述和解的可能。",
    ],
    reviews: [
      {
        author: "叶知秋",
        date: "2024-05-26",
        content: "很治愈，看完想给家里打个电话。",
      },
    ],
  },
  {
    id: "temperature-marriage",
    title: "婚姻的温度",
    type: "drama",
    year: 2023,
    genres: ["家庭伦理", "爱情伦理"],
    rating: 7.9,
    poster:
      "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20cinematic%20korean%20drama%20poster%20illustration%2C%20a%20dining%20table%20set%20for%20two%20with%20a%20single%20candle%2C%20moody%20intimate%20atmosphere%2C%20muted%20navy%20blue%20and%20warm%20amber%20tones%2C%20soft%20gradient%20background%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20no%20text&width=600&height=900&seq=kr-poster-16&orientation=portrait",
    director: "编导 · 吴世真",
    cast: ["林秀晶", "金宇振"],
    episodes: 16,
    tags: ["婚姻", "日常", "选择"],
    views: 74200,
    createdAt: "2024-06-05",
    synopsis: [
      "一对结婚十年的夫妻，在日复一日的平淡中渐渐失去了对话。一次意外的分开，让他们重新看清彼此在生活里的分量。",
      "剧集细腻地描摹长期关系里的疲惫与温柔。",
    ],
    reviews: [
      {
        author: "许一诺",
        date: "2024-06-09",
        content: "太真实了，很多场景就像在照镜子。",
      },
    ],
  },
  {
    id: "midnight-bookstore",
    title: "深夜书店",
    type: "drama",
    year: 2022,
    genres: ["治愈伦理", "都市伦理"],
    rating: 8.8,
    poster:
      "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20cinematic%20korean%20drama%20poster%20illustration%2C%20a%20cozy%20bookstore%20interior%20glowing%20warmly%20at%20midnight%2C%20moody%20intimate%20atmosphere%2C%20muted%20navy%20blue%20and%20warm%20amber%20tones%2C%20soft%20gradient%20background%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20no%20text&width=600&height=900&seq=kr-poster-17&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20artistic%20film%20still%20of%20a%20warm%20glowing%20old%20bookstore%20at%20midnight%2C%20cozy%20amber%20light%20spilling%20onto%20a%20quiet%20street%2C%20stylized%20cinematography%2C%20no%20text&width=1600&height=900&seq=kr-back-05&orientation=landscape",
    director: "编导 · 尹知恩",
    cast: ["韩素拉", "河俊浩"],
    episodes: 10,
    tags: ["治愈", "倾听", "城市"],
    views: 121600,
    createdAt: "2024-09-10",
    synopsis: [
      "一家只在午夜营业的书店，店主会为每位深夜到访的客人推荐一本书。每一个走进来的人，都带着白天无法说出口的故事。",
      "剧集用一个个温柔的单元故事，讨论如何与自己的过去和解。",
    ],
    reviews: [
      {
        author: "周叙",
        date: "2024-09-14",
        content: "今年最温柔的剧，每一集都像睡前读物。",
      },
      {
        author: "顾南枝",
        date: "2024-09-20",
        content: "配乐和画面都好治愈，适合深夜一个人慢慢看。",
      },
    ],
  },
  {
    id: "rose-lies",
    title: "玫瑰的谎言",
    type: "drama",
    year: 2024,
    genres: ["爱情伦理", "悬疑伦理"],
    rating: 8.1,
    poster:
      "https://readdy.ai/api/search-image?query=Elegant%20minimalist%20cinematic%20korean%20drama%20poster%20illustration%2C%20a%20single%20rose%20on%20a%20dark%20polished%20table%20with%20soft%20light%2C%20moody%20intimate%20atmosphere%2C%20muted%20navy%20blue%20and%20warm%20amber%20tones%2C%20soft%20gradient%20background%2C%20refined%20editorial%20composition%2C%20subtle%20film%20grain%2C%20no%20text&width=600&height=900&seq=kr-poster-18&orientation=portrait",
    director: "编导 · 崔敏贞",
    cast: ["林秀晶", "白贤宇"],
    episodes: 18,
    tags: ["谎言", "真心", "博弈"],
    views: 90500,
    createdAt: "2024-10-08",
    synopsis: [
      "一场精心设计的偶遇，让两个各怀目的的人走到一起。他们互相试探、互相成全，也逐渐分不清谎言与真心的界限。",
      "剧集以爱情为壳，讨论信任的建立与代价。",
    ],
    reviews: [
      {
        author: "沈知远",
        date: "2024-10-11",
        content: "男女主的对手戏张力十足，台词值得反复回味。",
      },
    ],
  },
];

export const editorPicks = [
  {
    id: "pick-2024",
    title: "2024 必看伦理电影",
    subtitle: "年度编辑精选",
    description:
      "从社会议题到私人情感，我们挑出今年最值得细看的一批韩国伦理电影，每一部都在追问那些没有标准答案的问题。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20artistic%20still%20of%20a%20dark%20empty%20cinema%20hall%20with%20warm%20projector%20light%20beams%20and%20soft%20glow%2C%20moody%20navy%20and%20amber%20tones%2C%20stylized%20editorial%20photography%2C%20no%20text&width=1200&height=800&seq=kr-pick-01&orientation=landscape",
    count: 10,
    link: "/category/erotic",
  },
  {
    id: "pick-classic",
    title: "经典伦理电视剧推荐",
    subtitle: "口碑长跑",
    description:
      "那些被反复讨论的伦理剧，用几十个小时陪伴人物成长。这里汇集了耐看、耐聊、经得起时间的电视剧专题。",
    cover:
      "https://readdy.ai/api/search-image?query=Atmospheric%20artistic%20still%20of%20a%20vintage%20television%20set%20in%20a%20moody%20dim%20room%20with%20soft%20warm%20light%2C%20retro%20editorial%20style%2C%20muted%20tones%2C%20no%20text&width=1200&height=800&seq=kr-pick-02&orientation=landscape",
    count: 8,
    link: "/category/drama",
  },
  {
    id: "pick-psyche",
    title: "心理伦理深度探索",
    subtitle: "向内观看",
    description:
      "当记忆、身份与自我认知开始动摇，人会如何选择？这一个专题献给喜欢在人物内心世界漫游的观众。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20artistic%20still%20of%20a%20reflective%20mirror%20maze%20in%20dim%20cool%20light%20with%20soft%20fog%2C%20conceptual%20editorial%20photography%2C%20muted%20tones%2C%20no%20text&width=1200&height=800&seq=kr-pick-03&orientation=landscape",
    count: 6,
    link: "/category/erotic",
  },
  {
    id: "pick-family",
    title: "家庭伦理温情专题",
    subtitle: "关于家的一切",
    description:
      "亲情的裂痕、沉默与和解，往往藏在最日常的细节里。这里收录那些让人想起自己家人的作品。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20artistic%20still%20of%20a%20family%20dinner%20table%20with%20soft%20window%20light%20and%20steaming%20dishes%2C%20nostalgic%20editorial%20photography%2C%20warm%20muted%20tones%2C%20no%20text&width=1200&height=800&seq=kr-pick-04&orientation=landscape",
    count: 5,
    link: "/category/drama",
  },
];